import parseJson from "../../../utils/Admin/helpers/parseJson"
import reader from "../../../utils/Admin/helpers/reader"
import { setReportMetaData } from "../../Admin/reports/reports.slice"
import { fetchJson, onUploadInit, setFileMetaData, toggleLoading, onUploadFailure, onUploadSuccess, resetUploadState, onInit, onRequestFailure, onRequestSuccess} from "./upload.slice"
import { postDetails } from '../../../services/Admin/http/http.services'
import { ApiPaths } from "../../../utils/Admin/constants/api-path.constants"
import { handleTokenState } from "../authentication/authentication.slice"

export const setJsonData = (file, name, fileType, distributor, togglePreviewMode) => {
    return async (dispatch) => {
        dispatch(toggleLoading(true))
        try {
            dispatch(setFileMetaData({ name, fileType }))
            dispatch(setReportMetaData({ name, fileType }))
            const readerResult = await reader(file, fileType)
            const jsonData = parseJson(readerResult, distributor)
            // console.log(jsonData);
            dispatch(fetchJson(jsonData))
            console.log(jsonData.length)
            if (jsonData.length === 0) {
                togglePreviewMode(false)
            }
            dispatch(toggleLoading(false))
            if (jsonData.length !== 0) {
                togglePreviewMode(true)
            }
        } catch (error) {
            console.log(error);
            dispatch(toggleLoading(false))
            throw error
        }

    }
}

export const postJsonData = (payload, distributor) => {
    return async(dispatch) => {
        dispatch(onUploadInit())
        dispatch(toggleLoading(true))
        try {
            const result = await postDetails(ApiPaths.Upload[distributor], payload)
            console.log(result);
            if (result === 500) {
                dispatch(onUploadFailure('Unable to establish connection to backend'))
                return
            }

            if (typeof result === 'undefined') {
                dispatch(onUploadFailure('Something went wrong. Unable to save data'))
            } else if (typeof result !== 'undefined') {
                if (result === 401) {
                    dispatch(toggleLoading(false))
                    sessionStorage.clear()
                    dispatch(handleTokenState(true))
                    setTimeout(() => {
                        dispatch(handleTokenState(false))
                    }, 3000)
                } else if (result.status_code === '00') {
                    dispatch(onUploadSuccess())
                } else if (result.status_code !== '00' && typeof result.status_desc !== 'undefined') {
                    dispatch(onUploadFailure(result.status_desc))
                } else {
                    dispatch(onUploadFailure('Something went wrong. Unable to save data'))
                }
            }

        } catch (error) {
            dispatch(onUploadFailure('Something went wrong. Unable to save data'))
            console.log(error);
        }
    }
}

export const getAllVendors = () => {
    return async (dispatch) => {
        try {
            dispatch(onInit())
            const result = await postDetails(ApiPaths.DROPDOWN_DATA_URL, {})
            if (result === 401) {
                dispatch(handleTokenState(true))
            }
            if (typeof result === 'number') {
                dispatch(onRequestFailure(result))
                return
            }

            if (typeof result.brokers !== 'undefined') {
                // console.log(result);
                dispatch(onRequestSuccess(result.brokers))
                return
            }

        } catch (error) {
            console.log(error);
            dispatch(onRequestFailure(5))
        }
    }
}

export const resetUploadStatus = () => {
    return (dispatch) => {
        dispatch(resetUploadState())
    }
}